import { useRef, useEffect, useState } from "react";


// QUERIES FOR LIST
import { listChatMessage } from "../../graphql/queries";


// SUBSCRIPTION FOR PINGING WEBSOCKET AND REAL-TIME UPDATES
import {
  // CHAT
  onCreateChatMessage,
  onUpdateChatMessage,
  onDeleteChatMessage
} from "../../graphql/subscriptions";

// MUTATIONS FOR CREATE , UPDATE AND DELETE
import {

  // CHAT
  createChatMessage,
  updateChatMessage,
  deleteChatMessage
} from "../../graphql/mutations";

import { generateClient } from "aws-amplify/api";

import { format } from "date-fns";
import { useAuth } from "../../contexts/AuthContext";



const Chat = ({selectedItem,chatMessages}) => {
    console.log(selectedItem.TransactionMessagesRelation?.items);
    console.log(chatMessages);
    const { user } = useAuth();
    const client = generateClient();
    const [message, setMessage] = useState("");
    const [chat, setChat] = useState([]);

    const [newChat, setNewChat] = useState([]);
    const [initialValue, setInitialValue] = useState(false);


    useEffect(() => {
      if (listRef.current) {
        listRef.current.innerHTML = '';
      }
      if(!initialValue){
        setChat(selectedItem.TransactionMessagesRelation?.items.length > 0 ? selectedItem.TransactionMessagesRelation?.items : [])
        setInitialValue(true);
      }
    }, []);

   
   



    useEffect(() => {

      if(initialValue){
        setNewChat(chatMessages.sort((a, b) => {
          const dateA = new Date(a.date_created);
          const dateB = new Date(b.date_created);
          return dateA - dateB; // Ascending order (oldest to newest)
        }));
      }
    }, [chatMessages]);


    

    const listRef = useRef(null);
    const listRefNewMessage = useRef(null);
    
 

      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleCreateChatMessage(e);
        }
      };
    
      const [chatError, setChatError] = useState(false);
      const handleCreateChatMessage = async (e) => {
        if(initialValue){
          if(chat.length === 1){
            setChat([]);
          }
        }
        e.preventDefault();
        setChatError(false);

        console.log("chatError", selectedItem.transaction_id);

        console.log("chattt",chat);
        console.log("newChat",newChat);

        let chatId = null;
        if(chat.length > 0 || newChat.length > 0){
          chatId = newChat[0]?.chat_id || chat[0]?.chat_id;
        }
      

        const input = {
          chat_id        : chatId,
          message        : message,
          user_profile_id: user.user_id,
          message        : message,
          date_created   : format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          transaction_id : selectedItem.transaction_id,
        };
        try {
          const mutationVariables = { input };
          await client.graphql({
            query: createChatMessage,
            variables: mutationVariables,
          });
          setMessage("");
        } catch (error) {
          setChatError(true);
        }
      };

      //  SCROLL TO LAST MESSAGE
  const lastMessageRef = useRef(null);

   
 
  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [chat,newChat,chatMessages]);

    return ( 

      
            <div>
              <div className="card card-action  chat-history-wrapper w-100 border shadow-none">
                <div className="card-header align-items-center pb-2">
                  <h5 className="card-action-title mb-0">
                    <i className="bx bxs-chat me-2" />
                    Chat
                  </h5>
                </div>

                <div className="card-body" style={{ height: 400, overflowY: "auto", background: "#f7f8f8", }} >
                  {chatError && (
                    <div className="alert alert-danger alert-dismissible mt-4 d-flex flex-column align-items-start w-100" role="alert" >
                      <span> Oops! You can't initiate chat. Only the principal is allowed. You can reply only. </span>
                      {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" ></button> */}
                    </div>
                  )}

                  {/* Chat Messages */}

                  <ul className="list-unstyled chat-history mt-2"  ref={listRef}>
                    {chat.length > 0 && 
                      chat.map((data, index) => {
                        // Extracting hour and minute from the current message and the previous one
                        const currentTime = new Date(data.createdAt);
                        const previousTime =
                          index > 0
                            ? new Date(chat[index - 1].createdAt)
                            : null;

                        // Check if the hour and minute are the same as the previous message
                        const showDatetime =
                          !previousTime ||
                          currentTime.getHours() !==
                            previousTime.getHours() ||
                          currentTime.getMinutes() !==
                            previousTime.getMinutes();

                        return data.user_profile_id.toString() === user.user_id.toString() ? (
                          <li key={data.id} className="chat-message chat-message-right d-flex flex-column justify-content-end flex-column align-items-end" >
                            {showDatetime && (
                              <div className="text-center w-100 text-body-secondary mt-1">
                                <small> {format( new Date(data.createdAt), "MMM dd h:mm a" )} </small>
                              </div>
                            )}
                            <div className="d-flex overflow-hidden">
                              <div className="d-flex flex-column align-items-end" style={{ maxWidth: 275 }} >
                                <div className="chat-messages bg-label-primary mb-1" style={{ width: "fit-content" }} >
                                  <p className="mb-0">{data.message}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li key={data.id} className="chat-message-li">
                            {showDatetime && (
                              <div className="text-center w-100 text-body-secondary mt-1">
                                <small> {format( new Date(data.createdAt), "MMM dd h:mm a" )} </small>
                              </div>
                            )}
                            <div className="d-flex overflow-hidden">
                              <div className="d-flex flex-column align-items-start">
                                <div className="chat-messages mb-1">
                                  <p className="mb-0">{data.message}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>



{/* NEW CHATS */}
                  <ul className="list-unstyled chat-history mt-2"  ref={listRefNewMessage}>
                  {newChat.length > 0 && 
                      newChat.map((data, index) => {
                        // Extracting hour and minute from the current message and the previous one
                        const currentTime = new Date(data.date_created);
                        const previousTime =
                          index > 0
                            ? new Date(newChat[index - 1].date_created)
                            : null;

                            console.log(data.date_created);

                        // Check if the hour and minute are the same as the previous message
                        const showDatetime =
                          !previousTime ||
                          currentTime.getHours() !==
                            previousTime.getHours() ||
                          currentTime.getMinutes() !==
                            previousTime.getMinutes();

                        return data.user_profile_id.toString() === user.user_id.toString() ? (
                          <li key={data.id} className="chat-message chat-message-right d-flex flex-column justify-content-end flex-column align-items-end" >
                            {showDatetime && (
                              <div className="text-center w-100 text-body-secondary mt-1">
                                <small> {format( new Date(data.date_created), "MMM dd h:mm a" )} </small>
                              </div>
                            )}
                            <div className="d-flex overflow-hidden">
                              <div className="d-flex flex-column align-items-end" style={{ maxWidth: 275 }} >
                                <div className="chat-messages bg-label-primary mb-1" style={{ width: "fit-content" }} >
                                  <p className="mb-0">{data.message}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li key={data.id} className="chat-message-li">
                            {showDatetime && (
                              <div className="text-center w-100 text-body-secondary mt-1">
                                <small> {format( new Date(data.date_created), "MMM dd h:mm a" )} </small>
                              </div>
                            )}
                            <div className="d-flex overflow-hidden">
                              <div className="d-flex flex-column align-items-start">
                                <div className="chat-messages mb-1">
                                  <p className="mb-0">{data.message}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>




                  <div ref={lastMessageRef} style={{height:75}} />
                </div>

                <div className="card-footer shadow-xs">
                  <div className="d-flex justify-content-between align-items-center ">
                    <input
                      value={message}
                      className="form-control message-input border-0 me-4 shadow-none"
                      placeholder="Type your message here..."
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                    <div className="message-actions d-flex align-items-center">
                      <button type="button" onClick={(e) => { handleCreateChatMessage(e); }} className="btn btn-primary d-flex send-msg-btn" >
                        <span className="align-middle d-md-inline-block d-none">
                          Send
                        </span>
                        <i className="icon-base bx bx-paper-plane icon-sm ms-md-2 ms-0" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
       
     );
}
 
export default Chat;